import type { AudienceRule } from '../audienceRules/audience-rule'

export class Audience {
    audienceId: string
    title: string
    total: number
    totalDistinct: number
    createdAt: Date
    updatedAt: Date
    status: number
    audienceRules: AudienceRule[]
    type: string
    persons?: any[]
    lastUpdate?: Date
    nextUpdate?: Date
    stage?: string
}
